import store from '@/store'
let axios = require('axios');

export const _tenant = () => store.state.tenant.current
export const _TENANT = () => store.state.tenant._current

export const _nav = () => store.state.nav

export const _user = () => store.state.auth.user.current
export const _USER = () => store.state.auth.user._current

export const _notifications = () => store.state.userNotifications.all
export const _NOTIFICATIONS = () => store.state.userNotifications._all

export const _game = () => store.state.games.current
export const _GAME = () => store.state.games._current

export const _games = () => store.state.games.all
export const _GAMES = () => store.state.games._all

export const _residents = () => store.state.tenant.residents.all
export const _RESIDENTS = () => store.state.tenant.residents._all

export const _sprints = () => store.state.sprints.current
export const _SPRINTS = () => store.state.sprints._current

export const _actions = () => store.state.actions.all
export const _ACTIONS = () => store.state.actions._all

export const _activities = () => store.state.activities.all
export const _ACTIVITIES = () => store.state.activities._all

export const _missions = () => store.state.missions.all
export const _MISSIONS = () => store.state.missions._all

export const _goals = () => store.state.goals.all
export const _GOALS = () => store.state.goals._all

export const _achievements = () => store.state.achievements.all
export const _ACHIEVEMENTS = () => store.state.achievements._all

export const _victories = () => store.state.victories.all
export const _VICTORIES = () => store.state.victories._all

export const _rewards = () => store.state.rewards.all
export const _REWARDS = () => store.state.rewards._all

export const _claims = () => store.state.claims.all
export const _CLAIMS = () => store.state.claims._all

export const _posts = () => store.state.posts.all
export const _POSTS = () => store.state.posts._all

export const _tips = () => store.state.tips.all
export const _TIPS = () => store.state.tips._all

export const LoadGames = async () => {
	await axios.all([store.dispatch('games/index')])
}

export const LoadState = async (game) => {
	let load = [store.dispatch('userNotifications/index')]

	if (!game) {
		await axios.all(load)
		return;
	}

	if (_USER().isAble('action:view')) {
		load.push(store.dispatch('actions/index'));
	}
	if (_USER().isAbleToAny(['mission:view'])) {
		load.push(store.dispatch('missions/index'));
	}
	if (_USER().isAbleToAny(['goal:view'])) {
		load.push(store.dispatch('goals/index'));
	}
	if (_USER().isAbleToAny(['achievement:viewAny', 'achievement:viewOwned'])) {
		load.push(store.dispatch('achievements/index'));
	}
	if (_USER().isAbleToAny(['victory:viewAny', 'victory:viewOwned'])) {
		load.push(store.dispatch('victories/index'));
	}
	if (_USER().isAbleToAny(['claim:viewAny', 'claim:viewOwned'])) {
		load.push(store.dispatch('claims/index'));
	}

	await axios.all(load)
}

export const ResetState = () => {
	_GAME().setState(false)
	_GAMES().commit.resetState()
	_RESIDENTS().commit.resetState()
	_ACTIONS().commit.resetState()
	_ACTIVITIES().commit.resetState()
	_MISSIONS().commit.resetState()
	_GOALS().commit.resetState()
	_ACHIEVEMENTS().commit.resetState()
	_VICTORIES().commit.resetState()
	_CLAIMS().commit.resetState()
	_POSTS().commit.resetState()
	_TIPS().commit.resetState()
}